import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { X, Save } from 'lucide-react';
import { fetchTransportes, selectAllTransportes } from '../../store/slices/transportesSlice';
import './EditCustomerModal.css';

const EditCustomerModal = ({ customer, onClose, onSave }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const transportes = useSelector(selectAllTransportes);

  // Determine if customer is exportación (USA or Canada) or nacional (Chile)
  const isExportacion = customer.pais === 'USA' || customer.pais === 'Canada';
  
  // Filter transportes by type
  const transportesFiltrados = transportes.filter(t => 
    t.tipo === (isExportacion ? 'exportacion' : 'nacional')
  );

  useEffect(() => {
    // Load transportes on mount
    dispatch(fetchTransportes());
  }, [dispatch]);

  useEffect(() => {
    // Initialize form data based on customer type
    if (isExportacion) {
      setFormData({
        transporte_id: customer.transporte_id || ''
      });
    } else {
      // Nacional
      setFormData({
        nombre_contacto: customer.nombre_contacto || '',
        telefono: customer.telefono || '',
        email_contacto: customer.email_contacto || '',
        direccion: customer.direccion || '',
        ciudad: customer.ciudad || '',
        transporte_id: customer.transporte_id || ''
      });
    }
  }, [customer, isExportacion]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onSave(customer.id, formData);
      onClose();
    } catch (error) {
      console.error('Error updating customer:', error);
      alert('Error al actualizar el cliente');
    } finally {
      setLoading(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-content edit-customer-modal">
        {/* Header */}
        <div className="modal-header">
          <div>
            <h2 className="modal-title">Editar Cliente</h2>
            <p className="modal-subtitle">{customer.nombre}</p>
            <span className="customer-type-badge">
              {isExportacion ? 'Exportación' : 'Nacional'}
            </span>
          </div>
          <button 
            className="btn-icon" 
            onClick={onClose}
            type="button"
          >
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {isExportacion ? (
              // Exportación: Only transporte
              <div className="form-group">
                <label className="form-label">Empresa de Transporte</label>
                <select
                  name="transporte_id"
                  className="form-input"
                  value={formData.transporte_id || ''}
                  onChange={handleChange}
                >
                  <option value="">Seleccione un transporte</option>
                  {transportesFiltrados.map(transporte => (
                    <option key={transporte.id} value={transporte.id}>
                      {transporte.nombre}
                    </option>
                  ))}
                </select>
              </div>
            ) : (
              // Nacional: Multiple fields
              <>
                <div className="form-group">
                  <label className="form-label">Nombre de Contacto</label>
                  <input
                    type="text"
                    name="nombre_contacto"
                    className="form-input"
                    value={formData.nombre_contacto || ''}
                    onChange={handleChange}
                    placeholder="Ingrese nombre de contacto"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Teléfono</label>
                  <input
                    type="text"
                    name="telefono"
                    className="form-input"
                    value={formData.telefono || ''}
                    onChange={handleChange}
                    placeholder="Ingrese teléfono"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Email de Contacto</label>
                  <input
                    type="email"
                    name="email_contacto"
                    className="form-input"
                    value={formData.email_contacto || ''}
                    onChange={handleChange}
                    placeholder="Ingrese email de contacto"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Dirección</label>
                  <input
                    type="text"
                    name="direccion"
                    className="form-input"
                    value={formData.direccion || ''}
                    onChange={handleChange}
                    placeholder="Ingrese dirección"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Ciudad</label>
                  <input
                    type="text"
                    name="ciudad"
                    className="form-input"
                    value={formData.ciudad || ''}
                    onChange={handleChange}
                    placeholder="Ingrese ciudad"
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">Empresa de Transporte</label>
                  <select
                    name="transporte_id"
                    className="form-input"
                    value={formData.transporte_id || ''}
                    onChange={handleChange}
                  >
                    <option value="">Seleccione un transporte</option>
                    {transportesFiltrados.map(transporte => (
                      <option key={transporte.id} value={transporte.id}>
                        {transporte.nombre}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onClose}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              <Save size={18} />
              {loading ? 'Actualizando...' : 'Actualizar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCustomerModal;
